/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { WriteWithAIRequestCurrentDoc } from './writeWithAIRequestCurrentDoc';
import type { WriteWithAIRequestSelectionDoc } from './writeWithAIRequestSelectionDoc';
import type { WriteWithAIRequestStepType } from './writeWithAIRequestStepType';

export interface WriteWithAIRequest {
  step_type: WriteWithAIRequestStepType;
  current_doc: WriteWithAIRequestCurrentDoc;
  selection_doc?: WriteWithAIRequestSelectionDoc;
  /**
     * @minLength 1
     * @maxLength 2000
     */
  user_intent: string;
  tone_preset?: string | null;
}
